import "./static/wave.png";
import "./static/blogpic.jpg";

import "./content_header.css";
